import { gql } from '@apollo/client';

/**
 * GraphQL query to fetch workflow configuration for a specific community
 */
export const GET_COMMUNITY_WORKFLOWS = gql`
  query GetCommunityWorkflows($communityId: ID!) {
    community(id: $communityId) {
      id
      workflowConfigurations {
        type
        topicActions {
          topicName
          actionNames
        }
        apiSettings {
          maxTps
          monthlyBudget
          costPerAudioHour
          numberOfClipsPerHour
          accessClients {
            providerUrl
            clientIdList
          }
          contentTypeTps {
            text
            image
            audio
          }
        }
      }
    }
  }
`;
